import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { CardContainer, LightButton } from "best-common-react";
import AdditionalOptions from "./AdditionalOptions";
import { CompConstants } from "../../constants/CompConstants";
import { ReportConstants } from "../../constants/ReportConstants";
import TimeFrames from "./TimeFrames";

class AwardComp extends React.Component {
  render() {
    let { trackingHelper } = this.props.rootStore;
    return (
      <React.Fragment>
        <CardContainer>
          <CardContainer.Body>
            <div className="container-fluid">
              <div className="row mx-0">
                <TimeFrames tab={CompConstants.TABS.AWARD} />
                <AdditionalOptions tab={CompConstants.TABS.AWARD} />
              </div>
            </div>
          </CardContainer.Body>
          <CardContainer.Footer>
            <div className="header-item-row">
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(ReportConstants.REPORT_AWARD, "Run Award Report Click");
                }}
              >
                Run Award Report
              </LightButton>
              <LightButton
                onClick={() => {
                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_AWARD_SUMMARY,
                    "Run Award Summary Report Click"
                  );
                }}
              >
                Run Award Summary Report
              </LightButton>
            </div>
          </CardContainer.Footer>
        </CardContainer>
      </React.Fragment>
    );
  }
}

AwardComp.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(AwardComp));
